import type { JwtPayload } from "../models/JwtPayload";

class JwtHelper {
  decode(token: string): JwtPayload | undefined {
    try {
      const parts = token.split(".");

      if (parts.length !== 3) {
        return undefined;
      }

      const encodedPayload = parts[1];
      const normalizedPayload = encodedPayload
        .replace(/-/g, "+")
        .replace(/_/g, "/")
        .padEnd(Math.ceil(encodedPayload.length / 4) * 4, "=");

      const decodedPayload = decodeURIComponent(
        window
          .atob(normalizedPayload)
          .split("")
          .map((character) => {
            const characterCode = character
              .charCodeAt(0)
              .toString(16)
              .padStart(2, "0");

            return `%${characterCode}`;
          })
          .join(""),
      );

      return JSON.parse(decodedPayload) as JwtPayload;
    } catch {
      return undefined;
    }
  }

  isExpired(token: string): boolean {
    const payload = this.decode(token);

    if (!payload?.exp) {
      return true;
    }

    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    return payload.exp <= currentTimeInSeconds;
  }

  isValid(token: string): boolean {
    return Boolean(this.decode(token)) && !this.isExpired(token);
  }
}

export const jwtHelper = new JwtHelper();
